<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/academy' }">
        <app-i18n code="entities.academy.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.academy.importer.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.academy.importer.title"></app-i18n>
      </h1>

      <app-importer storePath="academy/importer"></app-importer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-academy-importer-page',
};
</script>

<style>
</style>
